module.exports = __webpack_public_path__ + "static/media/img_feature_photo1@3x.b1054148.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SP/@3x/img_feature_photo1@3x.webp
// module id = 795
// module chunks = 0